import { render, staticRenderFns } from "./App.vue?vue&type=template&id=39acc0b3&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mapengsheng/Documents/LEARN/WEBPACK/marain-build-webpack2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39acc0b3')) {
      api.createRecord('39acc0b3', component.options)
    } else {
      api.reload('39acc0b3', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=39acc0b3&", function () {
      api.rerender('39acc0b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/search/App.vue"
export default component.exports